import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { combineLatest, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { ErrorService } from '../services/error.service';

@Injectable()
export class ConfirmUserGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private errorService: ErrorService
  ) {}

  canActivate() {
    return combineLatest([
      of(this.authService.temporaryUser),
      of(this.authService.temporaryCode)
    ]).pipe(
      tap(([user, code]) => {
        if (!user && !code) {
          this.router.navigate(['']);
        }
      }),
      switchMap(([user, code]) => {
        if (code) {
          this.authService.temporaryCode = '';
          return this.authService.confirm(code).pipe(
            tap(res => {
              if (!!res) {
                this.router.navigate(['']);
              }
            }),
            map(res => !!res),
            catchError(error => {
              this.errorService.captureError(error);

              this.authService.temporaryCodeError =
                error?.error?.error?.message || error?.message || 'Something went wrong';

              if (error?.error?.error?.type === 'CodeExpiredException') {
                this.authService.temporaryUser = error?.error?.error?.username;
              }

              return of(true);
            })
          );
        } else {
          return of(!!user);
        }
      })
    );
  }
}
